import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '../../contexts/AuthContext';
import AdminLogin from './AdminLogin';
import AdminLayout from './AdminLayout';
import AdminDashboard from './AdminDashboard';
import TeamManagement from './TeamManagement';
import TreatmentManagement from './TreatmentManagement';
import PopupManagement from './PopupManagement';
import ContactManagement from './ContactManagement';
import UserManagement from './UserManagement';
import AdminSettings from './AdminSettings';
import JobManagement from './JobManagement';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#f5f7f5' }}>
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4" style={{ borderColor: '#1B4D3E', borderTopColor: 'transparent' }} />
          <p className="text-gray-500">Laden...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin />;
  }

  if (requiredRole === 'admin' && user?.role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return <AdminLayout>{children}</AdminLayout>;
};

const AdminApp = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/team" element={
          <ProtectedRoute requiredRole="admin">
            <TeamManagement />
          </ProtectedRoute>
        } />
        <Route path="/jobs" element={
          <ProtectedRoute>
            <JobManagement />
          </ProtectedRoute>
        } />
        <Route path="/treatments" element={
          <ProtectedRoute requiredRole="admin">
            <TreatmentManagement />
          </ProtectedRoute>
        } />
        <Route path="/popups" element={
          <ProtectedRoute>
            <PopupManagement />
          </ProtectedRoute>
        } />
        <Route path="/contact" element={
          <ProtectedRoute>
            <ContactManagement />
          </ProtectedRoute>
        } />
        <Route path="/users" element={
          <ProtectedRoute requiredRole="admin">
            <UserManagement />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute requiredRole="admin">
            <AdminSettings />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  );
};

export default AdminApp;
